<template>
  <div class="qta_wrapper">
    <div :class="ans1_valid_cls1">
      <b-form-group label-for="input-ans1" label="정답*">
        <b-form-input id="input-ans1" v-model="ans1"> </b-form-input>
      </b-form-group>
    </div>

    <div :class="intent1_valid_cls1">
      <b-row>
        <b-col>출제포인트*</b-col>
      </b-row>
      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent1"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트1(필수)"
          label="name"
          track-by="name"
        ></multiselect>
      </div>

      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent2"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트2"
          label="name"
          track-by="name"
        ></multiselect>
      </div>

      <div class="multisel_wrapper bspace">
        <multiselect
          v-model="intent3"
          :options="intent_options"
          :custom-label="nameWithLang"
          placeholder="출제포인트3"
          label="name"
          track-by="name"
        ></multiselect>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
export default {
  components: { Multiselect },
  computed: {
    ans1: {
      get() {
        return this.$store.state.questionform.ans1;
      },
      set(val) {
        this.$store.commit("updateAns1", val);
      },
    },
    q_type_sub() {
      return this.$store.state.questionform.q_type_sub;
    },
    intent1_valid_cls1() {
      return this.$store.state.valid.intent1;
    },

    ans1_valid_cls1() {
      return this.$store.state.valid.ans1;
    },

    intent1: {
      set(val) {
        this.$store.commit("updateIntent1", val);
      },
      get() {
        return this.$store.state.questionform.intent1;
      },
    },
    intent2: {
      set(val) {
        this.$store.commit("updateIntent2", val);
      },
      get() {
        return this.$store.state.questionform.intent2;
      },
    },
    intent3: {
      set(val) {
        this.$store.commit("updateIntent3", val);
      },
      get() {
        return this.$store.state.questionform.intent3;
      },
    },

    intent_options() {
      return this.$store.state.intent_options;
    },
  },
  methods: {
    nameWithLang({ d1, d2, d3 }) {
      return `${d1} -> ${d2} -> ${d3}`;
    },
  },
};
</script>


<style lang="scss" scoped>
.invalid {
  border: 2px solid red;
  padding: 2px;
  margin: 2px;
}

.qta_wrapper {
  margin-bottom: 15px;
  .multisel_wrapper {
    margin-top: 5px;
  }
  .badgecls {
    padding: 6px;
    margin-bottom: 2px;
  }
  div {
    margin-bottom: 2px;
  }
}

.multiselect--active {
  z-index: 10;
}
.multiselect__content-wrapper {
  z-index: 10;
}
.bspace {
  margin-bottom: 15px;
}
</style>